import { useCreateAdjustmentBase } from "./useCreateAdjustmentBase"

import type {
  CreateAddNewPalletsInput,
  CreateInventoryAddPalletsAdjustmentMutation,
  CreateInventoryAddPalletsAdjustmentMutationVariables,
} from "@/graphql/codegen/graphql"
import { CreateInventoryAddPalletsAdjustmentDocument } from "@/graphql/codegen/graphql"

interface UseCreateAddPalletsAdjustmentReturn {
  createAdjustment: (input: CreateAddNewPalletsInput, comment?: string, document?: File) => Promise<boolean>
  isCreating: boolean
}

export const useCreateAddPalletsAdjustment = (): UseCreateAddPalletsAdjustmentReturn =>
  useCreateAdjustmentBase<
    CreateInventoryAddPalletsAdjustmentMutation,
    CreateInventoryAddPalletsAdjustmentMutationVariables,
    CreateAddNewPalletsInput
  >({
    documentNode: CreateInventoryAddPalletsAdjustmentDocument,
    getOutput: (data) => data.inventoryAdjustment.addNewPallets,
  })
